<template>
  <div>
    <div class="columns">
      <div class="column">
        <div class="field">
          <generic-dropdown
            :title="$t('roles')"
            :placeholder="$t('select allowed roles')"
            url="/system/role/catalog"
            name_field="name"
            value_field="role_id"
            @change="set_role"
            ref="role_dropdown"
          />
        </div>
      </div>
    </div>
    <!-- <div class="buttons is-pulled-right">
      <div class="button is-secondary is-rounded" @click="add">
        <span class="icon">
          <i class="fa fa-plus"></i>
        </span>
        <span>{{ $t("add") }}</span>
      </div>
    </div>
    <h5 class="title is-5 pt-3">{{ $t("users") }}</h5>
    <table class="table is-bordered is-fullwidth">
      <thead>
        <tr>
          <th>{{ $t("user") }}</th>
          <th>{{ $t("password") }}</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(rsrc, ridx) in meta.users" :key="ridx">
          <td>
            <input type="text" class="input" v-model="meta.users[ridx].user" />
          </td>
          <td>
            <input
              type="password"
              class="input"
              v-model="meta.users[ridx].password"
            />
          </td>
          <td>
            <div
              class="button is-secondary has-text-danger is-rounded"
              @click="meta.users.splice(ridx, 1)"
              :data-tooltip="$t('delete')"
            >
              <span class="icon">
                <i class="fa fa-trash"></i>
              </span>
            </div>
          </td>
        </tr>
      </tbody>
    </table> -->
  </div>
</template>

<script>
import GenericDropdown from "@/components/generic_dropdown/Index.vue";

export default {
  name: "System",
  components: {
    GenericDropdown,
  },
  data() {
    return {
      meta: { roles: [] },
    };
  },
  methods: {
    get_data() {
      return this.meta;
    },
    set_data(data) {
      let v = this;
      Object.keys(data).map((k) => {
        v.meta[k] = data[k];
      });
      if (data.roles) {
        v.$refs.role_dropdown.set_value(data.roles);
      }
    },
    clear() {
      this.meta = {
        roles: [],
      };
      this.$refs.role_dropdown.clear();
    },
    set_role(data) {
      let v = this;
      // console.log(data);
      v.meta.roles = data;
      // if (data == null) {
      //   v.meta.roles = [];
      // } else {
      //   if (Array.isArray(data)) {
      //     v.meta.roles = data.map((r) => {
      //       return r.role_id;
      //     });
      //   } else {
      //     v.meta.roles = [data.role_id];
      //   }
      // }
    },
  },
};
</script>
